(function() { window.GUID_d97382bb_71cb_48f6_8e53_49894d1a2528 = { getGuid: function() { return "d97382bb-71cb-48f6-8e53-49894d1a2528"; } }; })();
Number.prototype.map = function (in_min, in_max, out_min, out_max) {
    return (this - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};
// var num = 5
// num.map(0,10,0,100)  //retourne 50

//# sourceMappingURL=cs.math.js.map
